(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["contact-banner"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.cb__form').forEach(function (form) {
      var successEl = form.querySelector('[data-cb-success]');
      var errorEl   = form.querySelector('[data-cb-error]');
      var submitBtn = form.querySelector('[data-cb-submit]');

      function showError(msg) {
        if (errorEl) {
          var span = errorEl.querySelector('span');
          if (span) span.textContent = msg;
          errorEl.style.display = 'flex';
          errorEl.focus();
        }
      }

      // After a successful native submit, Shopify reloads the page with
      // ?contact_posted=true — reveal and scroll to the success message.
      if (window.location.search.indexOf('contact_posted=true') !== -1 && successEl) {
        successEl.style.display = 'flex';
        if (errorEl) errorEl.style.display = 'none';
        try { successEl.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (err) {}
      }

      form.addEventListener('submit', function (e) {
        // Client-side validation only. If it fails, block the submit and show the
        // error. Otherwise the form submits NATIVELY so Shopify handles it and
        // shows its success message on reload (no AJAX, no false error).
        var nameInput = form.querySelector('input[name="contact[name]"]');
        if (nameInput && !nameInput.value.trim()) {
          e.preventDefault();
          showError('Name is required.');
          return;
        }

        var emailInput = form.querySelector('input[name="contact[email]"]');
        if (emailInput) {
          var emailVal = emailInput.value.trim();
          var emailValid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailVal);
          if (!emailVal) {
            e.preventDefault();
            showError('Email is required.');
            return;
          }
          if (!emailValid) {
            e.preventDefault();
            showError('Please enter a valid email address.');
            return;
          }
        }

        // Valid — allow the native form submission to proceed. Defer disabling
        // the button so it never cancels the submit.
        if (errorEl) errorEl.style.display = 'none';
        if (submitBtn) setTimeout(function () { submitBtn.disabled = true; }, 0);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-products-carousel"] && !Shopify.designMode) return;
  try {
    
  class FeaturedCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-track]');
      this.prevButton = this.querySelector('[data-prev]');
      this.nextButton = this.querySelector('[data-next]');

      this.prevButton?.addEventListener('click', () => this.scrollByCard(-1));
      this.nextButton?.addEventListener('click', () => this.scrollByCard(1));
      this.track?.addEventListener('scroll', () => this.updateButtons(), { passive: true });
      window.addEventListener('resize', () => this.updateButtons());
      this.updateButtons();
    }

    cardStep() {
      const card = this.track?.querySelector('li');
      if (!card) return 0;
      const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      return card.getBoundingClientRect().width + gap;
    }

    scrollByCard(direction) {
      this.track?.scrollBy({ left: direction * this.cardStep(), behavior: 'smooth' });
    }

    updateButtons() {
      if (!this.track) return;
      const maxScroll = this.track.scrollWidth - this.track.clientWidth - 1;
      if (this.prevButton) this.prevButton.disabled = this.track.scrollLeft <= 0;
      if (this.nextButton) this.nextButton.disabled = this.track.scrollLeft >= maxScroll;
    }
  }

  if (!customElements.get('featured-carousel')) {
    customElements.define('featured-carousel', FeaturedCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-with-product-card"] && !Shopify.designMode) return;
  try {
    
  class IwpMediaSlider extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-track]');
      this.slides = this.track ? Array.from(this.track.children) : [];
      this.prevBtn = this.querySelector('[data-prev]');
      this.nextBtn = this.querySelector('[data-next]');

      const card = this.closest('.iwp__card');
      this.titleEl = card?.querySelector('[data-iwp-title]');
      this.priceEl = card?.querySelector('[data-iwp-price]');
      this.buttonEl = card?.querySelector('.iwp__button--card');
      this.badgeEl = card?.querySelector('[data-iwp-badge]');
      this.featuresEl = card?.querySelector('[data-iwp-features]');

      this.prevBtn?.addEventListener('click', () => this.move(-1));
      this.nextBtn?.addEventListener('click', () => this.move(1));
      this.track?.addEventListener('scroll', () => this.onScroll(), { passive: true });
      this.currentIndex = 0;
      this.updateArrows();
      this.syncDetails(0);
    }

    move(direction) {
      if (!this.track) return;
      const total = this.slides.length;
      const next = this.currentIndex + direction;
      if (next < 0 || next >= total) return;
      this.currentIndex = next;
      const width = this.track.clientWidth;

      // Fade out text elements before scrolling
      this._setTextOpacity(0.35);

      this.track.scrollTo({ left: this.currentIndex * width, behavior: 'smooth' });
      this.updateArrows();

      // Wait for the smooth scroll to finish (~350ms), then update + fade in
      clearTimeout(this._syncTimer);
      this._syncTimer = setTimeout(() => {
        this.syncDetails(this.currentIndex);
        this._setTextOpacity(1);
      }, 350);
    }

    _setTextOpacity(val) {
      if (this.titleEl)    this.titleEl.style.opacity    = val;
      if (this.priceEl)    this.priceEl.style.opacity    = val;
      if (this.buttonEl)   this.buttonEl.style.opacity   = val;
      if (this.badgeEl)    this.badgeEl.style.opacity    = val;
      if (this.featuresEl) this.featuresEl.style.opacity = val;
    }

    updateArrows() {
      const total = this.slides.length;
      if (this.prevBtn) {
        const atStart = this.currentIndex === 0;
        this.prevBtn.disabled = atStart;
        this.prevBtn.setAttribute('aria-disabled', String(atStart));
      }
      if (this.nextBtn) {
        const atEnd = this.currentIndex >= total - 1;
        this.nextBtn.disabled = atEnd;
        this.nextBtn.setAttribute('aria-disabled', String(atEnd));
      }
    }

    onScroll() {
      if (this._raf) return;
      this._raf = requestAnimationFrame(() => {
        this._raf = null;
        const width = this.track.clientWidth || 1;
        this.currentIndex = Math.round(this.track.scrollLeft / width);
        this.updateArrows();
        this.syncDetails(this.currentIndex);
      });
    }

    // When the slides carry product data (collection or blocks mode), keep the
    // card details in sync with the visible slide. Each field is guarded so a
    // slide that omits a value (e.g. collection slides carry no badge/features)
    // leaves that element untouched. No-op in single-product mode.
    syncDetails(index) {
      const slide = this.slides[index];
      if (!slide) return;
      if (this.titleEl && slide.dataset.title) this.titleEl.textContent = slide.dataset.title;
      if (this.priceEl && slide.dataset.price) this.priceEl.textContent = slide.dataset.price;
      if (this.buttonEl && slide.dataset.url) this.buttonEl.setAttribute('href', slide.dataset.url);

      // Badge — blocks carry a data-badge attribute (may be empty). Absent
      // attribute (collection mode) means "don't touch the shared badge".
      if (this.badgeEl && 'badge' in slide.dataset) {
        const badge = slide.dataset.badge;
        this.badgeEl.textContent = badge;
        this.badgeEl.hidden = badge === '';
      }

      // Features — blocks carry a <template data-features> of <li> items.
      if (this.featuresEl) {
        const tpl = slide.querySelector('template[data-features]');
        if (tpl) {
          const html = tpl.innerHTML.trim();
          this.featuresEl.innerHTML = html;
          this.featuresEl.hidden = html === '';
        }
      }
    }
  }

  if (!customElements.get('iwp-media-slider')) {
    customElements.define('iwp-media-slider', IwpMediaSlider);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tabbed-content"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const tab = event.target.closest('.tabsec__tab');
    if (!tab) return;

    const section = tab.closest('.tabsec');
    if (!section) return;

    const index = tab.getAttribute('data-tab');

    section.querySelectorAll('.tabsec__tab').forEach((item) => {
      const active = item === tab;
      item.classList.toggle('is-active', active);
      item.setAttribute('aria-selected', active ? 'true' : 'false');
    });

    section.querySelectorAll('.tabsec__panel').forEach((panel) => {
      const active = panel.getAttribute('data-panel') === index;
      panel.classList.toggle('is-active', active);
      panel.toggleAttribute('hidden', !active);
    });
  });

  // Activate the matching tab when a block is selected in the theme editor.
  document.addEventListener('shopify:block:select', (event) => {
    const button = document.querySelector(
      '.tabsec__tab[data-block-id="' + event.detail.blockId + '"]'
    );
    if (button) button.click();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials"] && !Shopify.designMode) return;
  try {
    
  class RevCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-track]');
      this.prevButton = this.querySelector('[data-prev]');
      this.nextButton = this.querySelector('[data-next]');

      this.prevButton?.addEventListener('click', () => this.scrollByCard(-1));
      this.nextButton?.addEventListener('click', () => this.scrollByCard(1));
      this.track?.addEventListener('scroll', () => this.updateButtons(), { passive: true });
      window.addEventListener('resize', () => this.updateButtons());
      this.updateButtons();
    }

    cardStep() {
      const card = this.track?.querySelector('li');
      if (!card) return 0;
      const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      return card.getBoundingClientRect().width + gap;
    }

    scrollByCard(direction) {
      this.track?.scrollBy({ left: direction * this.cardStep(), behavior: 'smooth' });
    }

    updateButtons() {
      if (!this.track) return;
      const maxScroll = this.track.scrollWidth - this.track.clientWidth - 1;
      if (this.prevButton) this.prevButton.disabled = this.track.scrollLeft <= 0;
      if (this.nextButton) this.nextButton.disabled = this.track.scrollLeft >= maxScroll;
    }
  }

  if (!customElements.get('rev-carousel')) {
    customElements.define('rev-carousel', RevCarousel);
  }

  } catch(e) { console.error(e); }
})();
})();
